import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';


@Injectable({
  providedIn: 'root'
})
export class MsService extends BaseApiTemplateService<any> {

  // readonly url = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'branches';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.PLATFORM_MICRO_SERVICES_URL_PREFIX + 'pg/' + 'app-mst-role';
    this.endpoint_path = Core2Config.PLATFORM_MICRO_SERVICES_URL_PREFIX + 'pg/' + 'app-mst-role';
    this.httpClient = http;
  }
}
